// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nb-0";